import React from 'react';
import { Spin, Empty } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ecrireExcel, ajouterEntete, tableauFinancierAoa, COL_WIDTHS_FINANCIER } from './excelUtils';
import { TableauFinancier, C, fmt } from './TableauReporting';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import { libellesTraduits } from '../../../i18n/libelles';

// MOIS_FR[1..12] : nom du mois dans la langue de l'interface, lu à l'usage.
const MOIS_FR = libellesTraduits('statistiques:commun.mois');
const tx = (cle, options) => i18n.t(`statistiques:reporting.${cle}`, options);

const SectionHeader = ({ title, note }) => (
  <div style={{ background: '#1e293b', color: '#fff', padding: '10px 16px',
    borderRadius: '10px 10px 0 0', display: 'flex',
    justifyContent: 'space-between', alignItems: 'center' }}>
    <span style={{ fontWeight: 700, fontSize: 13 }}>{title}</span>
    {note && <span style={{ fontSize: 11, opacity: 0.6 }}>{note}</span>}
  </div>
);

export function exportEncaissements(data) {
  if (!data) return;
  const m = MOIS_FR[data.mois].toUpperCase();
  const n = data.annee, n1 = data.anneeRef;
  const moisAnnee = `${MOIS_FR[data.mois]} ${n}`;
  const nbCols = 19;

  const buildSheet = (titre, lignes, total, getLabel) => {
    const aoaData = tableauFinancierAoa(titre, lignes, total, getLabel, m, n, n1);
    const { aoa, merges } = ajouterEntete(
      aoaData, tx('excel.entete.encaissements'), titre, moisAnnee, nbCols
    );
    return {
      name: titre.substring(0, 31),
      aoa, merges,
      colWidths: COL_WIDTHS_FINANCIER,
      rowHeights: [{hpt:16},{hpt:20},{hpt:16},{hpt:12},{hpt:28},{hpt:20},{hpt:16}],
    };
  };

  ecrireExcel([
    buildSheet(tx('excel.feuilles.parPaysPayeur'), data.parPays, data.totalPays, l=>l.pays),
    buildSheet(tx('excel.feuilles.marcheTogolais'), [...data.parCompagnie].sort((a,b)=>{
      if(a.compagnie==='AUTRES')return 1;if(b.compagnie==='AUTRES')return -1;
      return a.compagnie.localeCompare(b.compagnie);
    }), data.totalCompagnie, l=>l.compagnie),
  ], `Reporting_Enc_${MOIS_FR[data.mois]}_${n}`);
  toast.success(tx('excel.succes.encaissements'));
}

export default function TabEncaissements({ data, loading }) {
  const { t } = useTranslation('statistiques');
  if (loading) return (
    <div style={{ display:'flex', justifyContent:'center', padding:60 }}>
      <Spin indicator={<LoadingOutlined style={{ fontSize:28, color:C.green }} />} />
    </div>
  );
  if (!data) return <Empty description={t('commun.aucuneDonnee')} style={{ padding:40 }} />;

  const moisL = MOIS_FR[data.mois].toUpperCase();

  return (
    <div>
      {/* Tableau I */}
      <section style={{ marginBottom: 32 }}>
        <SectionHeader
          title={t('reporting.sections.encaissementsParPaysPayeur')}
          note={t('reporting.sections.inclutTogo')}
        />
        <TableauFinancier
          lignes={data.parPays}
          total={data.totalPays}
          getLabel={l => l.pays}
          moisLibelle={moisL}
          annee={data.annee}
          anneeRef={data.anneeRef}
        />
      </section>

      {/* Tableau II */}
      <section>
        <SectionHeader
          title={t('reporting.sections.marcheTogolais')}
          note={t('reporting.sections.compagniesMembresTogo')}
        />
        <TableauFinancier
          lignes={[...data.parCompagnie].sort((a,b) => {
            if (a.compagnie==='AUTRES') return 1;
            if (b.compagnie==='AUTRES') return -1;
            return a.compagnie.localeCompare(b.compagnie);
          })}
          total={data.totalCompagnie}
          getLabel={l => l.compagnie}
          moisLibelle={moisL}
          annee={data.annee}
          anneeRef={data.anneeRef}
        />
      </section>
    </div>
  );
}
